import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import client, { formatApiError } from "@/api/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await client.post("/auth/forgot-password", { email });
      setSuccess("If that email exists, a reset link has been sent. Check your inbox.");
    } catch (err) { setError(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] p-8">
      <div className="w-full max-w-sm fade-in">
        <div className="mb-8">
          <div className="w-10 h-10 bg-[#006080] rounded-lg flex items-center justify-center mb-4"><span className="text-white font-black">X</span></div>
          <h2 className="text-2xl font-bold text-gray-900">Forgot Password</h2>
          <p className="text-gray-500 text-sm mt-1">Enter your email and we'll send a reset link.</p>
        </div>
        {error && <div className="mb-4 p-3 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm">{error}</div>}
        {success ? (
          <div className="p-4 rounded-md bg-green-50 border border-green-200 text-green-700 text-sm">
            {success}
            <p className="mt-3"><Link to="/login" className="text-[#006080] font-semibold hover:underline">Back to login</Link></p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-1.5"><Label className="text-xs uppercase tracking-widest text-gray-500 font-semibold">Email Address</Label><Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required className="bg-white border-gray-200" /></div>
            <Button type="submit" className="w-full bg-[#006080] hover:bg-[#004d66] text-white font-semibold h-10" disabled={loading}>{loading ? "Sending..." : "Send Reset Link"}</Button>
          </form>
        )}
        {!success && <p className="mt-4 text-center text-sm text-gray-500"><Link to="/login" className="text-[#006080] hover:underline">Back to login</Link></p>}
      </div>
    </div>
  );
}
